import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { ReactComponent as AddSVG } from '@Assets/Svgs/ic_add.svg';
import { ReactComponent as MinusSVG } from '@Assets/Svgs/ic_minus.svg';
import TX from '../Text';

const Stepper = ({ min, max, count, onChange }) => {
  const isShowInitialDisplayCount = count === null;

  const isDisabledIncrementButton = max <= count;
  const isDisabledDecrementButton = min === count;
  const prefixCount = count > 0 ? '+' : '';

  const handleIncrementClick = () => {
    if (isDisabledIncrementButton) {
      return;
    }

    onChange(count + 1);
  };

  const handleDecrementClick = () => {
    if (isDisabledDecrementButton) {
      return;
    }

    onChange(count - 1);
  };

  return (
    <StepperContainer>
      <StepperButton disabled={isDisabledDecrementButton} onClick={handleDecrementClick}>
        <DecrementIcon disabled={isDisabledDecrementButton} />
      </StepperButton>

      <StepperCountContainer>
        <StepperCount>{isShowInitialDisplayCount ? '-' : `${prefixCount}${count}`}</StepperCount>
      </StepperCountContainer>

      <StepperButton disabled={isDisabledIncrementButton} onClick={handleIncrementClick}>
        <IncrementIcon disabled={isDisabledIncrementButton} />
      </StepperButton>
    </StepperContainer>
  );
};

Stepper.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  count: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

Stepper.defaultProps = {
  min: undefined,
  max: undefined,
  count: null,
};

const FlexAlignCenterCSS = css`
  display: flex;
  align-items: center;
`;

const StepperContainer = styled.div`
  ${FlexAlignCenterCSS}
  justify-content: space-between;

  flex: 1;
  height: 28px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.ui_1};
  border: 1px solid ${({ theme }) => theme.colors.ui_3};

  overflow: hidden;
`;

const StepperCountContainer = styled.div`
  ${FlexAlignCenterCSS}
  justify-content: center;

  height: 100%;
  flex: 1;
  border-left: 1px solid ${({ theme }) => theme.colors.ui_3};
  border-right: 1px solid ${({ theme }) => theme.colors.ui_3};
`;

const StepperCount = styled(TX.FootnoteM)``;

const StepperButton = styled.button`
  ${FlexAlignCenterCSS}
  justify-content: center;

  width: 24px;
  height: 100%;
  padding: 6px 4px;
  border: 0;
  background-color: transparent;
  cursor: pointer;

  &:disabled {
    background-color: ${({ theme }) => theme.colors.ui_2};
  }
`;

const StepperIconCSS = css`
  width: 16px;
  height: 16px;

  opacity: ${({ disabled }) => disabled && 0.5};
`;

const DecrementIcon = styled(MinusSVG)`
  ${StepperIconCSS}
`;

const IncrementIcon = styled(AddSVG)`
  ${StepperIconCSS}

  stroke: ${({ theme }) => theme.colors.ui_on_3};
`;

export default Stepper;
